// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { ReactNode } from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { card } from '../../typography';

type Props = {
  children: ReactNode;
  style?: ViewStyle;
};

/**
 * The surface every editor group sits on, matching the cards in round-init so
 * tour setup reads as the same screen family.
 */
export default function EditorCard({ children, style }: Props) {
  return <View style={[styles.card, style]}>{children}</View>;
}

const styles = StyleSheet.create({
  card,
});
